import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { ButtonFilled, Flex, SvgIcon } from 'Components/Base';
import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';
import { PATHS } from 'Routes/Main/paths';
import ExamResultsCard from 'Routes/GuidedPractice/Components/ExamRoom/ExamResultsCard';
import InnerLayout from 'Routes/GuidedPractice/Components/InnerLayout';
import ThumbnailCard from 'Routes/GuidedPractice/Components/ThumbnailCard';
import EmptyState from 'Routes/GuidedPractice/Components/EmptyState';

const ExamResultsWrapper = styled(Flex)`
  flex-direction: column;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.backgroundNeutralLightgrey};
  border-radius: 16px;
  gap: 8px;

  /* Webkit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Firefox */
  scrollbar-width: none;
`;

const ExamResultList = ({ examPaperItemViews, setExamResultSelected }) => {
  const history = useHistory();
  const { t } = useTranslation('guidedPractice');
  const { isTablet } = useCompatibleDisplay();

  const handleRedirectToSolution = (examQuestion) => {
    setExamResultSelected(examQuestion);
  };

  if (!examPaperItemViews || !examPaperItemViews.length) {
    return (
      <InnerLayout>
        <EmptyState
          title={'ไม่พบผลลัพธ์การทำแบบฝึกทบทวน'}
          action={
            <ButtonFilled
              data-testid={'back-button'}
              py={4}
              px={6}
              mt={4}
              width={198}
              borderRadius={300}
              onClick={() => history.replace(PATHS.guidedPractice)}
            >
              {t('BUTTON.BACK_TO_MAIN')}
            </ButtonFilled>
          }
        />
      </InnerLayout>
    );
  }

  return (
    <InnerLayout style={{ maxWidth: 820 }}>
      <Flex flexDirection={'column'} gridRowGap={4} mt={4}>
        <ThumbnailCard
          title={t('EXAM_ROOM.RESULT.FEEDBACK.TITLE')}
          description={t('EXAM_ROOM.RESULT.FEEDBACK.DESCRIPTION')}
          icon={SvgIcon.ICON_LIST.APPROVAL}
        />
        <ExamResultsWrapper isTablet={isTablet}>
          {examPaperItemViews.map((item) => {
            return (
              <ExamResultsCard
                key={item.id}
                item={item}
                isCorrect={item.isCorrect}
                questionNo={item.questionNo}
                onClick={() => handleRedirectToSolution(item)}
                isTablet={isTablet}
              />
            );
          })}
        </ExamResultsWrapper>
      </Flex>
      <Flex mt={7} justifyContent={'center'}>
        <ButtonFilled
          data-testid={'back-button'}
          py={4}
          px={6}
          width={198}
          borderRadius={300}
          onClick={() => history.replace(PATHS.guidedPractice)}
        >
          {t('BUTTON.BACK_TO_MAIN')}
        </ButtonFilled>
      </Flex>
    </InnerLayout>
  );
};

ExamResultList.propTypes = {
  examPaperItemViews: PropTypes.array,
  setExamResultSelected: PropTypes.func,
};

export default ExamResultList;
